module.exports = __webpack_public_path__ + "img/image10.98fe7177.png";